import { motion } from 'framer-motion';
import type { ContentWrapperProps } from '../props';

export const ContentWrapper = ({
    children,
    className = 'w-full',
    delay = 0,
}: ContentWrapperProps) => (
    <motion.div
        className={className}
        initial={{ y: 5, opacity: 0 }}
        animate={{ y: 0, opacity: 1, transition: { delay } }}
    >
        {children}
    </motion.div>
);
